import { TZDate } from '@date-fns/tz';
import { toISODateFormat } from '@shared/utils/dateFormatters';
import { Reservation } from './apiHelpers';

export enum ReservationStatusLabel {
  Canceled = 'Reservation Canceled',
  Completed = 'Reservation Completed',
  Confirmed = 'Reservation Confirmed',
  Rebooked = 'Reservation Rebooked',
  Sold = 'Reservation Sold',
}

export const getReservationStatusLabel = (
  reservation: Pick<Reservation, 'date' | 'status' | 'time'>,
  timezone: string,
): ReservationStatusLabel => {
  if (reservation.status === 'canceled') {
    return ReservationStatusLabel.Canceled;
  }

  if (reservation.status === 'resold') {
    return ReservationStatusLabel.Sold;
  }

  if (reservation.status === 'rebooked') {
    return ReservationStatusLabel.Rebooked;
  }

  if (reservation.status === 'finished') {
    return ReservationStatusLabel.Completed;
  }

  const currentDateInRestaurantTZ = toISODateFormat(TZDate.tz(timezone));

  if (reservation.date >= currentDateInRestaurantTZ) {
    return ReservationStatusLabel.Confirmed;
  }

  return ReservationStatusLabel.Completed;
};
